import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class CashMemoDirectService extends GenericService {
  constructor() {
    super('/cash_memo_directs', axiosInstance);
  }
}

export default new CashMemoDirectService(); 